<mat-dialog-content class="side-dialog-container">
  <ng-content></ng-content>
</mat-dialog-content>
